/** Unified browse categories — hero on desktop, pills above jobs on mobile */
export const POPULAR_CATEGORIES = [
  { label: 'Fresher jobs', mobileLabel: 'Fresher', href: '/jobs-for-freshers' },
  { label: 'Work from home', mobileLabel: 'Remote', href: '/work-from-home-jobs-vacancies' },
  { label: 'Government jobs', mobileLabel: 'Government', href: '/government-jobs-vacancies' },
  { label: 'IT & Software', mobileLabel: 'IT & Software', href: '/it-software-jobs-vacancies' },
  { label: 'Bank jobs', mobileLabel: 'Bank', href: '/bank-jobs-vacancies' },
  { label: 'Sales & Marketing', mobileLabel: 'Sales', href: '/sales-and-marketing-jobs-vacancies', showOnMobile: false },
  { label: 'Apprenticeship', mobileLabel: 'Apprenticeship', href: '/apprenticeship-jobs-vacancies' },
];

export const TRENDING_COURSES = [
  {
    category: 'Banking',
    name: 'HDFC Bank ACE Banker Program',
    institute: 'NIIT IFBI · Graduate banking careers',
    tagline: 'Accomplish your career aspirations with virtual learning and mentor-led sessions.',
    bullets: ['Monthly stipend during training', 'Placement guarantee on successful completion'],
    stat: 'Assistant Manager role at HDFC Bank',
    badge: 'Placement-focused',
    linkLabel: 'View program',
    url: 'https://learnforjobs.niit.com/india/graduates/banking-and-finance/hdfc-bank-ace-banker-program?utm_source=Affiliate&utm_medium=Affiliate_Hireclap&utm_campaign=Affiliate_Jan_HDFC_Hireclap',
    image: 'https://d346d97h6tf74r.cloudfront.net/hireclap/static_images/2026/03/061772797848.jpg',
  },
  {
    category: 'Finance',
    name: 'PG Diploma in Finance & Accounts',
    institute: 'MentorKart Academy',
    tagline: 'Stock market and finance simplified — live classes, assignments, and expert mentors.',
    bullets: ['Daily live classes & doubt sessions', 'Practical trading & accounting skills'],
    stat: 'Career-ready finance certification',
    badge: 'Popular',
    linkLabel: 'Explore course',
    url: 'https://www.mentorkart.com/academy-lp/pg-diploma-in-Finance-and-accounts?utm_medium=Hireclap',
    image: 'https://d346d97h6tf74r.cloudfront.net/hireclap/static_images/2026/03/061772797595.jpg',
  },
  {
    category: 'AI & Tech',
    name: 'PG Diploma in AI/ML & Agentic AI',
    institute: 'Futurense · IIT Gandhinagar',
    tagline: 'Residential program in AI, machine learning, and agentic AI engineering.',
    bullets: ['IIT Gandhinagar academic partnership', 'Hands-on labs & industry projects'],
    stat: 'Future-ready AI engineering skills',
    badge: 'IIT partner',
    linkLabel: 'View program',
    url: 'https://www.futurense.com/iit-gandhinagar/residential-pg-diploma-in-ai-ml-agentic-ai-engineering?utm_source=Hireclap&utm_medium=homepage&utm_campaign=ai_ml_pg',
    image: '/images/futurense-ai-ml-course.avif',
  },
];

/** Home card excerpts when the posts list API has no short_description */
export const FEATURED_CHALLENGE_EXCERPTS = [
  {
    match: /employability/i,
    excerpt: 'Most candidates fail before the interview — in aptitude and reasoning. This 30-minute test shows where you stand, similar to first-round screens at top companies.',
  },
];

export const POPULAR_CITIES = [
  { name: 'Bangalore', href: '/jobs-in-bangalore', image: '/Assets/images/logo/bangalore.svg' },
  { name: 'Mumbai', href: '/jobs-in-mumbai', image: '/Assets/images/logo/mumbai.svg' },
  { name: 'Chennai', href: '/jobs-in-chennai', image: '/Assets/images/logo/chennai.svg' },
  { name: 'Hyderabad', href: '/jobs-in-hyderabad', image: '/Assets/images/logo/hyderabad.svg' },
  { name: 'Delhi', href: '/jobs-in-delhi', image: '/Assets/images/logo/delhi.svg' },
  { name: 'Kolkata', href: '/jobs-in-kolkata', image: '/Assets/images/logo/kolkata.svg' },
  { name: 'Ahmedabad', href: '/jobs-in-ahmedabad', image: '/Assets/images/ahamedabad.svg' },
  { name: '800+ cities', href: '/jobs-by-cities', image: '/Assets/images/more-cities.svg', isMore: true },
];

export const HOME_ORG_JSONLD = {
  '@context': 'http://schema.org',
  '@type': 'Organization',
  name: 'Hireclap',
  url: process.env.VUE_APP_URL,
  logo: 'https://d22r5huxahsjvt.cloudfront.net/Assets/images/hireclap-logo-HD.png',
  contactPoint: [{
    '@type': 'ContactPoint',
    telephone: '+919037156256',
    contactType: 'Customer Service',
    areaServed: 'India',
  }],
};

/** Shared home FAQ copy — used by visible accordion and FAQPage JSON-LD */
export const HOME_FAQ_ITEMS = [
  {
    id: 'hp-faq-a',
    question: 'How does Hireclap help jobseekers find jobs?',
    schemaQuestion: 'How Hireclap helps jobseeker to find jobs?',
    answers: [
      'Hireclap is a video profile based job portal. Post a 2-minute visume instead of a conventional resume — recruiters across 5000+ companies can discover and shortlist you.',
      'Candidates with a video profile see up to 40% higher shortlisting rates. We aggregate fresher, government, IT, remote, and internship opportunities across India.',
    ],
    schemaAnswer: '<p>Hireclap.com is a video profile based job portal that helps jobseekers to find the best matching jobs. Jobseekers can post a 2 minute video profile (video resume / visume) , instead of the conventional resume. This video resume is accessible to all active recruiters.</p><p>Based on our last year hiring trends, we have observed that candidates with video resume has got a 40% higher shortlisting probability, than a similar candidate without visume.</p><p>More than 5000 companies are actively hiring from our platform for their entry level fresher hiring roles .Also we are aggregating all leading Govt jobs , private jobs , work from home jobs , internship opportunities, freelance jobs, sales & marketing jobs etc.</p><p>Hireclap is now one of the largest video profile based job portal with more than 3 million job seekers registered.</p><p>Create your Hireclap profile today -with an impressive video profile. All the best.</p>',
  },
  {
    id: 'hp-faq-b',
    question: 'How is Visume different from a resume?',
    schemaQuestion: 'How is Visume different from a resume?',
    answers: [
      'Visume is a short video introduction that showcases your communication, personality, skills, and experience — far beyond what a document resume can convey.',
      'For recruiters, visume-based shortlisting is a fast, transparent way to evaluate fit before scheduling interviews.',
    ],
    schemaAnswer: '<p>Visume is a 2 minute video introduction. You can showcase your uniqueness, skills , abilities, recognitions, experience & why should a company hire you.</p><p>Visume talks about you - much more than a conventional document based resume.</p><p>For companies - visume based shortlisting is a convenient way to find best matching candidates virtually, without meeting you. It\'s a transparent , effective way to hire right fit candidates for companies.</p>',
  },
  {
    id: 'hp-faq-c',
    question: 'Tips for a great video profile',
    schemaQuestion: 'Tips to create best video profile for a good first impression',
    answers: [
      'Keep it under 2 minutes. Cover: a warm introduction, education, work experience or internships, key skills, achievements, and a confident sign-off.',
      'Register on Hireclap for sample videos and more tips. Your face is the best interface — make a strong first impression.',
    ],
    schemaAnswer: '<p>Recruiters often review hundreds of applications for the same role. A short video introduction helps you stand out: they can see how you communicate, present yourself, and explain your fit—beyond what fits on one page. Many companies now use phone or video screening early, so being comfortable on camera is part of the hiring process.</p><p>The must-have points to include in an impressive video resume are</p><ul><li>A nice introduction</li><li>Education background</li><li>Brief about your prior work experience/internships</li><li>Your skills</li><li>Achievement / Awards / Recognitions</li><li>Sign off (Conclusion)</li></ul><p>Register and access your profile page for more tips, sample videos on how to create an attractive 2 minute video profile introduction.Your face is the best interface.Update your video profile & create a good first impression among recruiters.</p>',
  },
  {
    id: 'hp-faq-d',
    question: 'What type of job opportunities are posted on Hireclap?',
    schemaQuestion: 'What type of job opportunities are posted on Hireclap ?',
    answers: [
      'Most postings are fresher and entry-level roles. We also list experienced openings across engineering, MBA, IT, government, work-from-home, and freelance categories.',
      'Browse by city, course, or category — from Bangalore and Mumbai to IT software, bank jobs, and diploma roles. Visit All jobs or Jobs by cities to explore active openings.',
    ],
    schemaAnswer: '<p>Most of the job postings on Hireclap are for fresher / entry level job opportunities. We are posting experienced level jobs too.</p><p>Also we are aggregating relevant jobs for engineering , MBA, IT software, Government jobs , work from home jobs , all types for freelance jobs etc.All sorts of B Tech engineering job opportunities - be it mechanical engineering jobs,Electrical engineering jobs, biotechnology jobs, electrical engineering jobs, MCA Jobs etc. We are posting graduate , post graduate, 12th or 10th pass out jobs. In the field of commerce and accountants, we have CA (chartered accountant) jobs, company secretary jobs. Apart from this we have BBA jobs, supply chain management jobs, diploma jobs etc.</p><p>You can also find jobs based on popular categories like IT software , core engineering , Online teaching , upskilling opportunities etc .Also jobs are sorted based on popular cities like Jobs from Bangalore, Jobs from Mumbai , Jobs from Chennai , Jobs from Hyderabad, Jobs from Delhi, Jobs from Kolkata , Jobs from Ahmedabad , Jobs from tier 2 & 3 cities etc . Visit the ‘Jobs by cities’ section.We have jobs across all fields including Research, management,call center, BPO, Engineering, medical, testing , technical jobs etc.</p><p>Visit the \'All jobs\' section to access active jobs & fInd the best matching jobs as per your job role, location preferences</p>',
  },
];

export const HOME_FAQ_JSONLD = {
  '@context': 'https://schema.org',
  '@type': 'FAQPage',
  mainEntity: HOME_FAQ_ITEMS.map(item => ({
    '@type': 'Question',
    name: item.schemaQuestion || item.question,
    acceptedAnswer: {
      '@type': 'Answer',
      text: item.schemaAnswer,
    },
  })),
};

export function getHomeBreadcrumbJsonld() {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [{
      '@type': 'ListItem',
      position: 1,
      name: 'Home',
      item: typeof window !== 'undefined' ? window.location.href : process.env.VUE_APP_URL,
    }],
  };
}
